/** @module SiteAdmin/DomainClassName */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/StringTypeNotSortable",
	"csi/locale",
	"csi/reflection"
], function(declare,_,StringTypeNotSortable,locale,reflection) {

	var _mapDuplicateNames = null;

	/**
	 * Return true if given name is the name for multiple domain classes
	 * @param {string} name
	 * @return {boolean}
	 */
	function _isDuplicateName(name) {
		if (!_mapDuplicateNames) {
			var nameMap = {};

			_mapDuplicateNames = {};

			_.each(reflection.getDomainClasses(), function(dc) {
				var s = locale.type(dc.type);
				if (nameMap[s]) {
					_mapDuplicateNames[s] = true;
				} else {
					nameMap[s] = true;
				}
			});
		}

		return _mapDuplicateNames[name];
	}

	return declare(StringTypeNotSortable, {
		/**
		 * Render localized domain class name, including the type to distinguish between similarly named classes
		 * @param {Any} value
		 * @param {string} fmt
		 * @return {string}
		 */
		formatValue: function(value, fmt) {
			var s = this.inherited(arguments);

			if (_isDuplicateName(s)) {
				s += " (" + value + ")";
			}

			return s;
		},

		/**
		 * Use this renderer to get proper formatting
		 * @param {Context} ctx
		 * @param {Spec} spec
		 * @return {Object}
		 */
		getQuerySpec: function(ctx, spec) {
			var qs = this.inherited(arguments);
			qs.ren = this;
			return qs;
		}
	});
});